import {Controller} from "stimulus"
import $ from 'jquery';
import {get} from "@rails/request.js";
export default class extends Controller {
    static targets = ["status","dateRange",'dateInitRange','rentCount','rentDaysCount','totalBilling','totalEarning','agencyFilter','destinationFilter','poleFilter','productFilter','officeFilter']

    initialize() {}

    connect() {
      this.filter();
    }

    filter(e){
        this.show_loading();
        let context = this;
        get(`/commercial/filter`, {
            query: {
                status: context.statusTarget.value,
                range: context.dateRangeTarget.value,
                init: context.dateInitRangeTarget.value,
            },
            responseKind: "turbo-stream"
        }).then(r => {

        })
    }

    exportar(e){
        let context = this;

        get(`/commercial/export/${e.target.dataset.format}`, {
            query: {
                status: context.statusTarget.value,
                range: context.dateRangeTarget.value,
                init: context.dateInitRangeTarget.value,
            },
            responseKind: "html"
        })
    }

    show_loading(){
         $(this.rentCountTarget).html('<span class="fa fa-circle-o-notch fa-spin"></span>')
         $(this.rentDaysCountTarget).html('<span class="fa fa-circle-o-notch fa-spin"></span>')
        $(this.totalBillingTarget).html('<span class="fa fa-circle-o-notch fa-spin"></span>')
        $(this.totalEarningTarget).html('<span class="fa fa-circle-o-notch fa-spin"></span>')
        $(this.agencyFilterTarget).html('<span class="fa fa-circle-o-notch fa-spin"></span>')
        $(this.destinationFilterTarget).html('<span class="fa fa-circle-o-notch fa-spin"></span>')
        $(this.poleFilterTarget).html('<span class="fa fa-circle-o-notch fa-spin"></span>')
        $(this.productFilterTarget).html('<span class="fa fa-circle-o-notch fa-spin"></span>')
        $(this.officeFilterTarget).html('<span class="fa fa-circle-o-notch fa-spin"></span>')
    }

}